import { buildServiceLevelSignedFileUrl } from './buildServiceLevelSignedFileUrl'

/** @deprecated 互換のためのエイリアス。新規コードは buildServiceLevelSignedFileUrl を使用してください。 */
export const buildServiceLevelFeedbackImageUrl = buildServiceLevelSignedFileUrl
